import React, { useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import trial1 from '../../images/trial1.png';
import trial2 from '../../images/trial2.png';
import trial3 from '../../images/trial3.png';
import user from '../../images/user.png';
import email from '../../images/email.png';
import phone from '../../images/phone.png';
import company from '../../images/company.png';
import country from '../../images/country.png';
import bed from '../../images/bed.png';
import { useNavigate } from 'react-router-dom';

const TrialFrom = (props) => {

    const navigate = useNavigate()

    const [isOpen, setOpen] = useState(false)
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        hotelName: '',
        rooms: '',
        address: '',
        comments: ''
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess(false);
        try {
            await axios.post('https://n8n.srv806265.hstgr.cloud/webhook/emh-form-78946-311ffc01-fbcb-42f8-a45646-788-rdfhj-917-47ea89b5c047', formData);
            setSuccess(true);
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                hotelName: '',
                rooms: '',
                address: '',
                comments: ''
            });

            navigate('/thankyou')

        } catch (err) {
            setError('Submission failed. Please try again.');
        }
        setLoading(false);
    };
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="trial_section section_space">
            <div className="container">
                <div className="row">
                   <div className="col-lg-12 text-center">
                       <h2>Try Ease My Hotel for free.</h2>
                       <p className='mb-0'>No lock-in contracts. Cancel anytime</p>
                       {/* <p className='mb-0'>Just fill in this quick form:</p> */}
                    </div>

                    <div className="col-lg-5">
                          <div className='trial_form_inside'>
                                <h3>Best Hotel & Resort <br/> Management Software</h3>
                                <div className='trial_form_inside_item'><img src={trial1}/> <p>All-in-one hotel and vacation rental management software</p></div>
                                <div className='trial_form_inside_item'><img src={trial2}/> <p>Run your property with ease, whether you're at the front desk or off-site.</p></div>
                                <div className='trial_form_inside_item'><img src={trial3}/> <p>Manage your property from a single platform with ease</p></div>
                          </div>
                    </div>
                    <div className="col-lg-7">
                        <form className="trial_form row" onSubmit={handleSubmit}>
                           <div className="form-group col-lg-6">
                                <img src={user} alt="User" />
                                <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" className="form-control" required />
                            </div>
                            <div className="form-group col-lg-6">
                                <img src={user} alt="User" />
                                <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name"  className="form-control" required />
                            </div>
                            <div className="form-group col-lg-6">
                               <img src={email} alt="User" />
                                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address"  className="form-control" required />
                            </div>
                            <div className="form-group col-lg-6">
                               <img src={phone} alt="User" />
                                <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="form-control" required />
                            </div>
                            <div className="form-group col-lg-6">
                               <img src={company} alt="User" />
                                <input type="text" name="hotelName" value={formData.hotelName} onChange={handleChange} placeholder="Hotel name" className="form-control" required />
                            </div>
                            <div className="form-group col-lg-6">
                            <img src={bed} alt="User" />
                                <input type="text" name="rooms" value={formData.rooms} onChange={handleChange} placeholder="Number of Rooms" className="form-control" required />
                            </div>
                            <div className="form-group col-lg-12">
                            <img src={country} alt="User" />
                                <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Enter Address" className="form-control" required />
                            </div>

                            <div className="form-group col-lg-12">
                                <textarea name="comments" value={formData.comments} onChange={handleChange} placeholder="Comments" className="form-control" style={{padding:"15px 25px 25px"}}></textarea>
                            </div>

                            {error && <div className="text-danger mb-2">{error}</div>}
                            {success && <div className="text-success mb-2">Form submitted successfully!</div>}
                            <ul className='unordered_list p-0 justify-content-start'>
                                <li>
                                    <button type="submit" className='btn' disabled={loading}>
                                        <span className='btn_label' data-text='Try for Free'>
                                            {loading ? 'Submitting...' : 'Try for Free'}
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrialFrom;